import { BaseConfig } from "../config.interface";
import { Validate } from "../util";

interface IRadioButtonConfig {
    label?: string;
    validate: Validate;
}

export class RadioButtonConfig extends BaseConfig<IRadioButtonConfig> implements IRadioButtonConfig {
    /**
     * Label of the element.
     */
    label?: string;
    /**
     * Show validation status already in `pristine` state or after it has been marked as `dirty`.
     */
    validate: Validate;

    /**
     * @theme Base
     */
    static baseTheme = {
        /**
         * Default configuration.
         */
        Default: new RadioButtonConfig({
            validate: "dirty"
        }),
    };
}
